import React, { FunctionComponent } from 'react';

import { getErrorReason } from 'scenes/common/helpers/apiData';
import {
  ApiErrorReasonType,
  ErrorPageApiErrorReasonType,
  InsuranceName,
  InsuredItem,
} from 'scenes/common/types';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { QuoteErrorPage as CommonQuoteErrorPage } from 'scenes/common/components/Error';
import analytics from 'scenes/landlord/analytics';

import { Declined, Embargo, Unknown } from './components';

export const QuoteErrorPage: FunctionComponent<Pick<
  LandlordFullPageProps,
  'funnelState' | 'onRestartQuote'
>> = ({ onRestartQuote, funnelState }) => {
  const { quoteNumber, type } = getErrorReason(
    funnelState.apiResponses.quoteDetails
  );

  return (
    <CommonQuoteErrorPage
      quoteNumber={quoteNumber}
      insuranceName={InsuranceName.Landlord}
      itemInsured={InsuredItem.Property}
      errorReasonType={type as ErrorPageApiErrorReasonType}
      specificImages={{
        [ApiErrorReasonType.Declined]: () => <Declined />,
        [ApiErrorReasonType.Embargo]: () => <Embargo />,
        [ApiErrorReasonType.Unknown]: () => <Unknown />,
      }}
      onClickCallUs={() => analytics().callUs(funnelState)}
      onRestartQuote={onRestartQuote}
    />
  );
};

export default QuoteErrorPage;
